import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Typography, TableCell, TableRow } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';

import { ManualNotificationsItem } from 'api';
import { Numeric } from 'components';

interface IProps extends WithStyles<typeof styles> {
  checkbox?: (item: ManualNotificationsItem) => ReactNode;
  item: ManualNotificationsItem;
}

const MAX_BODY_LENGTH = 140;

const styles = (theme: Theme) =>
  createStyles({
    row: {
      height: 92,
    },
    cell: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    icon: {
      marginRight: theme.spacing(0.5),
      fontSize: 16,
    },
  });

const Row: FC<IProps> = ({ classes, checkbox, item }) => {
  const { t } = useTranslation();

  function getName(rowData: ManualNotificationsItem) {
    if (rowData.entire_company) {
      return t('components:registeredUsers');
    }
    return rowData.segments.map(segment => segment.title).join(', ');
  }

  function getBody() {
    const { body } = item.message;

    if (body.length <= MAX_BODY_LENGTH) {
      return body;
    }
    return `${body.slice(0, MAX_BODY_LENGTH - 3)}...`;
  }

  return (
    <TableRow key={item.id} className={classes.row}>
      <TableCell padding="none">{!!checkbox && checkbox(item)}</TableCell>
      <TableCell padding="none">
        <Typography variant="body2" color="textPrimary">
          {item.send_at ? moment.unix(item.send_at).format('l') : '--'}
        </Typography>
        <Typography color="textSecondary">
          {item.send_at ? moment.unix(item.send_at).format('h:mm A') : '--'}
        </Typography>
      </TableCell>
      <TableCell className={classes.cell} style={{ width: '70%' }}>
        <Typography variant="body2" color="textPrimary">
          {getName(item)}
        </Typography>
        <Typography color="textSecondary">{getBody()}</Typography>
      </TableCell>
      <TableCell padding="none" align="right">
        {!!item.email && <MailIcon fontSize="small" color="disabled" className={classes.icon} />}
        {!!item.message && (
          <NotificationsIcon fontSize="small" color="disabled" className={classes.icon} />
        )}
      </TableCell>
      <TableCell align="center">
        <Typography variant="subtitle2">
          <Numeric value={item.user_count + item.email_count} />
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default withStyles(styles)(Row);
